import { render, staticRenderFns } from "./QueryNewReview.vue?vue&type=template&id=1825d67f&scoped=true&"
import script from "./QueryNewReview.vue?vue&type=script&lang=js&"
export * from "./QueryNewReview.vue?vue&type=script&lang=js&"
import style0 from "./QueryNewReview.vue?vue&type=style&index=0&id=1825d67f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1825d67f",
  null
  
)

export default component.exports